// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { subscribeStyles } from "@synd/Overrides/Widgets/Basic/Subscribe";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { layoutContainer, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

subscribeStyles.mainGridContainer = {
    css: css`
        display: flex;
        column-gap: 22px;
        justify-content: center;
        padding-top: 24px;
        ${layoutContainer}
        ${xScreen("lte", "md")} {
            column-gap: 20px;
        }
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            row-gap: 16px;
        }
    `,
};

subscribeStyles.titleAndDescriptionWrapper = {
    css: css`
        max-width: 508px;
        flex: 1;
        ${xScreen("lte", "lg")} {
            max-width: 430px;
        }
        ${xScreen("lte", "md")} {
            max-width: 100%;
        }
    `,
};

subscribeStyles.formAndDisclaimerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
        position: relative;
        max-width: 508px;
        flex: 1;
        ${xScreen("lte", "lg")} {
            max-width: 430px;
        }
        ${xScreen("lte", "md")} {
            max-width: 100%;
        }
    `,
};

subscribeStyles.emailButton = {
    variant: "secondary",
    css: css`
        position: absolute;
        right: 4px;
        top: 4px;
        height: 26px;
        min-height: 26px;
        width: 95px;
    `,
};

subscribeStyles.emailTextField = {
    cssOverrides: {
        formInputWrapper: css`
            min-height: 34px;
        `,
        inputSelect: css`
            &,
            &:focus,
            &[aria-invalid="true"],
            &[aria-invalid="true"]:focus {
                padding-right: 100px;
            }
        `,
    },
};

subscribeStyles.titleLabel = {
    variant: "h4",
    forwardAs: "h3",
};

subscribeStyles.descriptionText = {
    ...fontConfig.xSmall,
    css: css`
        ${TypographyStyle} {
            font-size: ${fontConfig.xSmall.size}px;
            line-height: ${fontConfig.xSmall.lineHeight};
        }
    `,
};

subscribeStyles.disclaimerGridItem = {
    css: css`
        line-height: ${fontConfig.xxxSmallSingleLine.lineHeight};
    `,
};

subscribeStyles.disclaimerText = {
    size: fontConfig.xxxSmallSingleLine.size,
};

subscribeStyles.emailGridItem = {
    css: css`
        display: flex;
    `,
};
